import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ------------------------Get Referral List------------------
export const getReferralApi = async (data) => {
  const endPoint =
    `/referral` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const getUserReferralApi = async (data) => {
  const endPoint =
    `/referral/user` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
